export enum DownloadInitiator {
    OrderHistory = 'order-history',
    BulkDownload = 'bulk-download',
    DownloadCart = 'download-cart',
    LightBox = 'light-box',
    SummaryBar = 'summary-bar'
}
